'use client';

import { useCallback, useEffect, useState } from 'react';
import { DEMO_DATA_EVENT, getDemoData } from './demoStorage';
import { cloneDemoSeed } from './demoData';
import type { DemoData } from './demoTypes';

export function useDemoData(): DemoData {
  const [data, setData] = useState<DemoData>(() => cloneDemoSeed());
  const refresh = useCallback(() => setData(getDemoData()), []);
  useEffect(() => {
    refresh();
    window.addEventListener(DEMO_DATA_EVENT, refresh);
    window.addEventListener('storage', refresh);
    return () => { window.removeEventListener(DEMO_DATA_EVENT, refresh); window.removeEventListener('storage', refresh); };
  }, [refresh]);
  return data;
}
